module.exports = __webpack_public_path__ + "1792771649312/fonts/Urbanist-Medium.70e637e.ttf";